import { CodeTypeModel } from '../../app-lite/core/models/code-type';
import { UserModel }     from '../../app-lite/users/models/user';
import { XeroService }   from '../../app-lite/xero/xero.service';

export class XeroCountryCtrl {
  form : ng.IFormController;
  user : UserModel;

  constructor (
    private $window : ng.IWindowService,
    private messages: any,
    private xeroApi : XeroService,
    public countries: Array<CodeTypeModel>
  ) {}

  goToCountry () {
    this.xeroApi.getSignupUrlFromCountry(this.user.country)
    .then(( url : string ) => {
      this.$window.location.assign(url);
    })
    .catch(err => {
      this.messages.error(err);
    });
  }
}
